import enums from '@happylife-a/enums';
import webCore from '@happylife-a/web-core';

export const StatusEnum = Object.freeze({
  redirect: 'redirect',
  formSubmit: 'form_submit',
  error: 'error',
  success: 'success',
});

export async function handlePaymentProcessingResponse(response) {
  if (response.status === enums.payment.PaymentResponseStatusEnum.redirect) {
    window.location.href = response.redirect.url;
    return;
  }

  if (response.status === enums.payment.PaymentResponseStatusEnum.openWidget) {
    return webCore.coreFactories.paymentMethodUseCase.completeWidgetPaymentMethodAttachment(
      response.widgetData.paymentMethodId,
      {
        paymentProvider: response.widgetData.provider,
        params: {
          widgetData: response.widgetData,
          data: response.data,
        },
      }
    );
  }

  if (response.status === enums.payment.PaymentResponseStatusEnum.formSubmit) {
    const form = document.createElement('form');
    form.method = response.submit.method;
    form.action = response.submit.url;

    for (const [name, value] of Object.entries(response.submit.data || {})) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    // debugger;
    document.body.appendChild(form);
    form.submit();

    return;
  }
}
